import React from 'react'

const CodingItem = ({item}) => {
    return (
        <li >
            <div className="name">{item.name}</div>
            <div className={`progress p${item.value}`}>
                <span>{item.value}%</span>
            </div>
        </li>
    )
}

export default CodingItem